export const size = {
    xs: 375,
    sm: 480,
    md: 768,
    lg: 992,
    xl: 1024,
    laptopL: 1366,
    xxl: 1440,
    gigantic: 1600,
    huge: 1920,
    colossal: 2560
};

export const device = {
    xs: `(max-width: ${size.xs}px)`,
    sm: `(max-width: ${size.sm}px)`,
    md: `(max-width: ${size.md}px)`,
    lg: `(max-width: ${size.lg}px)`,
    xl: `(max-width: ${size.xl}px)`,
    laptopL: `(max-width: ${size.laptopL}px)`,
    xxl: `(max-width: ${size.xxl}px)`,
    gigantic: `(max-width: ${size.gigantic}px)`,
    huge: `(max-width: ${size.huge}px)`,
    colossal: `(max-width: ${size.colossal}px)`
};

export const screens = {
    xs: { max: `${size.xs}px` },
    sm: { max: `${size.sm}px` },
    md: { max: `${size.md}px` },
    lg: { max: `${size.lg}px` },
    xl: { max: `${size.xl}px` },
    laptopL: { max: `${size.laptopL}px` },
    xxl: { max: `${size.xxl}px` },
    gigantic: { max: `${size.gigantic}px` },
    huge: { max: `${size.huge}px` },
    colossal: { max: `${size.colossal}px` }
};
